import { connect } from 'react-redux';
import React, { PropTypes } from 'react';

import PageSelector from 'components/PageSelector';
import { getMailPaging } from 'selectors';
import * as actions from 'actions';

export const MailMailThreadMessagesListPageSelector = (props) => {
  const { threadId, ...otherProps } = props; //eslint-disable-line no-unused-vars
  return <PageSelector {...otherProps} />;
};

MailMailThreadMessagesListPageSelector.propTypes = {
  threadId: PropTypes.string
};

const mapStateToProps = (state, props) => getMailPaging(state, 'mailThreadMessages', {threadId: props.threadId});

const mapDispatchToProps = (dispatch, props) => {
  return {
    onPrevClick: (currentPage) => {
      dispatch(actions.mailThreadMessagesFetch(props.threadId, currentPage - 1));
    },
    onNextClick: (currentPage) => {
      dispatch(actions.mailThreadMessagesFetch(props.threadId, currentPage + 1));
    },
    onPossiblePageUpdate: (newPossiblePage) => {
      dispatch(actions.mailThreadMessagesUpdatePossiblePage(props.threadId, newPossiblePage));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.mailThreadMessagesFetch(props.threadId, newPage));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailMailThreadMessagesListPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessagesListPageSelector/index.js
 **/